import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Address } from '@mwe/models';
import { CardWithProductListComponent } from './card-with-product-list.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-vertrags-konto-product-list',
  templateUrl: './vertrags-konto-product-list.component.html',
  imports: [CardWithProductListComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VertragsKontoProductListComponent {
  categories = input.required<string[]>();
  accountNumber = input.required<string>();
  address = input<Address>();
  noBox = input<boolean>();
  oneRow = input<boolean>(true);
}
